import { AlertIcon } from '@approvalmax/ui';
import { Alert, Button, Checkbox, Flex, Form, Popup, Spacing, Text } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { memo } from 'react';
import bemFactory from 'react-bem-factory';

import { useTransferOrganisationPopupData } from './PopupTransferOrganisation.hooks';
import { messages } from './PopupTransferOrganisation.messages';
import { popupTransferOrganisationState } from './PopupTransferOrganisation.states';
import { PopupTransferOrganisationProps } from './PopupTransferOrganisation.types';

const qa = bemFactory.qa('cps-transfer-organisation-popup');

export const PopupTransferOrganisation = memo<PopupTransferOrganisationProps>((props) => {
    const { company } = props;

    const [isOpenTransferPopup, toggleTransferPopup] = useAtom(popupTransferOrganisationState);
    const { form, onFormSubmit, hasAccount, canTransfer } = useTransferOrganisationPopupData(company);

    return (
        <Popup size='small' open={isOpenTransferPopup} onToggle={toggleTransferPopup} data-qa={qa()}>
            <Popup.Header title={messages.title} />

            <Popup.Body>
                <Form form={form} onSubmit={onFormSubmit}>
                    <Flex container direction='column' spacing='24'>
                        <Flex size={24}>
                            <Text font='label' fontSize='medium'>
                                {messages.description}
                            </Text>
                        </Flex>

                        {!hasAccount && (
                            <Flex size={24}>
                                <Alert
                                    startIcon={<AlertIcon size={24} />}
                                    size='small'
                                    color='midnight20'
                                    alignItems='center'
                                >
                                    {messages.descriptionCreateAccount}
                                </Alert>

                                <Spacing height={24} />

                                <Checkbox name='agreed'>{messages.confirmCheckboxText}</Checkbox>
                            </Flex>
                        )}

                        <Flex size={24}>
                            <Button
                                block
                                size='medium'
                                color='blue80'
                                disabled={!canTransfer}
                                data-qa={qa('transfer-button')}
                            >
                                {messages.transferButton}
                            </Button>
                        </Flex>
                    </Flex>
                </Form>
            </Popup.Body>
        </Popup>
    );
});

PopupTransferOrganisation.displayName = 'PopupTransferOrganisation';
